import { useParams, Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Testimonials } from "@/components/sections"
import { PageMeta } from "@/components/shared/PageMeta"
import {
	TreatmentPlans,
	TreatmentAbout,
	TreatmentHowItWorks,
	TreatmentFaqs,
	TrustStrip,
	TreatmentCta,
	TreatmentContact
} from "@/components/sections/treatment"
import TREATMENTS, { isTreatment, type TreatmentId } from "@/content/treatments"
import { getTreatmentContent } from "@/content/treatments-content"
import { testimonials } from "@/content/home"
import { treatmentOgImagePath } from "@/lib/seo"

export default function TratamientoDetailPage(): React.JSX.Element {
	const { slug } = useParams<{ slug: string }>()

	if (!slug || !isTreatment(slug)) {
		return (
			<>
				<PageMeta
					title="Tratamiento no encontrado"
					description="El tratamiento que buscas no existe o ya no está disponible."
					path={`/tratamientos/${slug ?? ""}`}
				/>
				<div className="mx-auto max-w-3xl px-4 py-20 text-center">
					<p className="text-lg text-muted-foreground">Tratamiento no encontrado.</p>
					<Button asChild className="mt-6">
						<Link to="/tratamientos">Volver a tratamientos</Link>
					</Button>
				</div>
			</>
		)
	}

	const id = slug as TreatmentId
	const treatment = TREATMENTS[id]
	const content = getTreatmentContent(id)
	const condition = `${treatment.as} ${treatment.name.toLowerCase()}`

	return (
		<>
			<PageMeta
				title={`Tratamiento para ${treatment.name}`}
				description={content.tagline}
				image={treatmentOgImagePath(id)}
				path={`/tratamientos/${slug}`}
			/>
			{/* 1. Detalles: encabezado + tarjetas comparativas Básico / Completo */}
			<TreatmentPlans treatment={treatment} tagline={content.tagline} />

			{/* 2. Descripción: intro y problemas que resuelve */}
			<TreatmentAbout description={content.description} solves={content.solves} />

			{/* Cómo funciona la bioestimulación celular */}
			<TreatmentHowItWorks condition={condition} how={content.how} image={content.image} />

			{/* 3. Preguntas frecuentes */}
			<TreatmentFaqs faqs={content.faqs} />

			{/* 4. Confianza de compra */}
			<TrustStrip />

			{/* 5. Testimoniales (reutilizados del inicio) */}
			<Testimonials title="Opiniones de nuestros pacientes" items={testimonials} />

			{/* 6. CTA final de compra */}
			<TreatmentCta treatment={treatment} />

			{/* 7. Contacto */}
			<TreatmentContact treatmentId={id} />
		</>
	)
}
